"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var Paypal = function Paypal() {
  return react_1.default.createElement(Svg_1.default, {
    width: '64px',
    height: '16px',
    viewBox: '0 0 64 16'
  }, react_1.default.createElement("g", {
    id: "XMLID_7_",
    transform: "translate(0.015)"
  }, react_1.default.createElement("g", {
    id: "XMLID_22_",
    transform: "translate(-0.015)"
  }, react_1.default.createElement("g", {
    id: "XMLID_23_"
  }, react_1.default.createElement("g", {
    id: "XMLID_39_"
  }, react_1.default.createElement("g", {
    id: "XMLID_40_"
  }, react_1.default.createElement("path", {
    id: "XMLID_65_",
    className: "st0",
    style: {
      fill: '#0046D1'
    },
    d: "M24.3,6.8c-0.2,1.3-1.2,1.3-2.1,1.3h-0.5l0.4-2.4c0-0.1,0.1-0.3,0.3-0.2h0.2\n\t\t\t\t\t\tc0.5-0.1,1.1,0,1.6,0.3C24.4,6.1,24.4,6.5,24.3,6.8z M23.9,3.5h-3.6c-0.2,0-0.4,0.2-0.5,0.4L18.5,13c0,0.1,0.1,0.3,0.2,0.3\n\t\t\t\t\t\tc0,0,0.1,0,0.1,0h1.7c0.2,0,0.4-0.2,0.5-0.4l0.4-2.4c0-0.2,0.2-0.4,0.5-0.4H23c2,0.2,3.8-1.2,4-3.3c0,0,0-0.1,0-0.1\n\t\t\t\t\t\tc0.2-0.8,0-1.6-0.4-2.3C25.9,3.7,24.9,3.4,23.9,3.5L23.9,3.5z"
  }), react_1.default.createElement("path", {
    id: "XMLID_62_",
    className: "st0",
    style: {
      fill: '#0046D1'
    },
    d: "M32.2,10.1c-0.1,0.9-0.9,1.6-1.9,1.6c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.3-0.8-0.2-1.2\n\t\t\t\t\t\tc0.1-0.9,0.9-1.6,1.9-1.6c0.4,0,0.8,0.1,1.1,0.4C32.2,9.2,32.2,9.7,32.2,10.1z M34.5,6.8h-1.7c-0.1,0-0.3,0.1-0.3,0.2l-0.1,0.5\n\t\t\t\t\t\tl-0.1-0.2c-0.5-0.5-1.3-0.8-2-0.7c-1.9,0.1-3.5,1.5-3.8,3.4c-0.2,0.9,0,1.9,0.6,2.6c0.6,0.6,1.3,0.9,2.1,0.9\n\t\t\t\t\t\tc0.9,0,1.7-0.3,2.3-1L31.6,13c0,0.1,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0h1.5c0.2,0,0.4-0.2,0.5-0.4l0.9-5.8\n\t\t\t\t\t\tC34.8,7,34.8,6.8,34.5,6.8C34.6,6.8,34.6,6.8,34.5,6.8z"
  }), react_1.default.createElement("path", {
    id: "XMLID_61_",
    className: "st0",
    style: {
      fill: '#0046D1'
    },
    d: "M43.6,6.8h-1.7c-0.1,0-0.3,0.1-0.4,0.2l-2.3,3.5l-1-3.3c-0.1-0.2-0.3-0.4-0.5-0.3H36\n\t\t\t\t\t\tc-0.2,0-0.3,0.2-0.3,0.3c0,0,0,0,0,0.1l1.9,5.5l-1.8,2.5c-0.1,0.1-0.1,0.3,0.1,0.4c0,0,0.1,0.1,0.2,0.1h1.7\n\t\t\t\t\t\tc0.1,0,0.3-0.1,0.4-0.2l5.7-8.2c0.1-0.1,0.1-0.3-0.1-0.4C43.7,6.8,43.6,6.8,43.6,6.8z"
  }), react_1.default.createElement("path", {
    id: "XMLID_58_",
    className: "st1",
    style: {
      fill: '#336BDA'
    },
    d: "M49.6,6.8c-0.2,1.3-1.2,1.3-2.1,1.3H47l0.4-2.4c0-0.1,0.1-0.3,0.3-0.2h0.2\n\t\t\t\t\t\tc0.5-0.1,1.1,0,1.6,0.3C49.6,6.1,49.7,6.5,49.6,6.8z M49.2,3.5h-3.6c-0.2,0-0.4,0.2-0.5,0.4L43.7,13c0,0.1,0.1,0.3,0.2,0.3\n\t\t\t\t\t\tc0,0,0.1,0,0.1,0h1.8c0.2,0,0.3-0.1,0.3-0.3l0.4-2.6c0-0.2,0.2-0.4,0.5-0.4h1.1c2,0.2,3.8-1.2,4-3.3c0,0,0-0.1,0-0.1\n\t\t\t\t\t\tc0.2-0.8,0-1.6-0.4-2.3C51.1,3.7,50.1,3.4,49.2,3.5z"
  }), react_1.default.createElement("path", {
    id: "XMLID_53_",
    className: "st1",
    style: {
      fill: '#336BDA'
    },
    d: "M57.4,10.1c-0.1,0.9-0.9,1.6-1.9,1.6c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.3-0.8-0.2-1.2\n\t\t\t\t\t\tc0.1-0.9,0.9-1.6,1.9-1.6c0.4,0,0.8,0.1,1.1,0.4C57.4,9.2,57.5,9.7,57.4,10.1z M59.8,6.8h-1.7c-0.1,0-0.3,0.1-0.3,0.2l-0.1,0.5\n\t\t\t\t\t\tl-0.1-0.2c-0.5-0.5-1.3-0.8-2-0.7c-1.9,0.1-3.5,1.5-3.8,3.4c-0.2,0.9,0,1.9,0.6,2.6c0.6,0.6,1.3,0.9,2.1,0.9\n\t\t\t\t\t\tc0.9,0,1.7-0.3,2.3-1L56.9,13c0,0.1,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0h1.5c0.2,0,0.4-0.2,0.5-0.4l0.9-5.8\n\t\t\t\t\t\tC60.1,6.9,60,6.8,59.8,6.8L59.8,6.8z"
  }), react_1.default.createElement("path", {
    id: "XMLID_45_",
    className: "st1",
    style: {
      fill: '#336BDA'
    },
    d: "M61.8,3.8L60.3,13c0,0.1,0.1,0.3,0.2,0.3c0,0,0.1,0,0.1,0h1.5c0.2,0,0.4-0.2,0.5-0.4\n\t\t\t\t\t\tL64,3.8c0-0.1-0.1-0.3-0.2-0.3c0,0-0.1,0-0.1,0H62C61.9,3.5,61.8,3.6,61.8,3.8z"
  }), react_1.default.createElement("path", {
    id: "XMLID_43_",
    className: "st1",
    style: {
      fill: '#336BDA'
    },
    d: "M11.9,4c0,0.1,0,0.2,0,0.3C11.2,7.5,9,8.7,6.3,8.7H4.8c-0.3,0-0.6,0.2-0.7,0.6l-0.7,4.6\n\t\t\t\t\t\tl-0.2,1.3c0,0.2,0.1,0.4,0.3,0.4c0,0,0,0,0,0h2.5c0.3,0,0.5-0.2,0.6-0.5l0-0.1l0.5-3l0-0.1c0-0.3,0.3-0.5,0.6-0.5h0.4\n\t\t\t\t\t\tc2.4,0,4.3-1,4.9-3.9c0.3-1,0.1-2.1-0.5-2.9C12.5,4.3,12.2,4.1,11.9,4z"
  }), react_1.default.createElement("path", {
    id: "XMLID_42_",
    className: "st0",
    style: {
      fill: '#0046D1'
    },
    d: "M11.3,3.7c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.8-0.1-1.3-0.1H5.6\n\t\t\t\t\t\tc-0.1,0-0.2,0-0.2,0C5.2,3.6,5,3.8,5,4L4.2,9.1v0.1c0-0.3,0.3-0.6,0.7-0.6h1.4c2.8,0,5-1.1,5.6-4.4c0-0.1,0-0.2,0-0.3\n\t\t\t\t\t\tC11.7,3.9,11.6,3.8,11.3,3.7L11.3,3.7z"
  }), react_1.default.createElement("path", {
    id: "XMLID_41_",
    className: "st2",
    style: {
      fill: '#336BDA'
    },
    d: "M5,4c0-0.2,0.2-0.4,0.3-0.4c0.1,0,0.2-0.1,0.2,0h3.8c0.4,0,0.8,0,1.3,0.1\n\t\t\t\t\t\tc0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0C11.6,3.9,11.8,4,12,4.1c0.3-1,0-2-0.6-2.8C10.6,0.3,9.2,0,7.6,0H2.7\n\t\t\t\t\t\tC2.4,0,2.1,0.2,2.1,0.6L0,13.4c0,0.2,0.1,0.4,0.3,0.5c0,0,0,0,0.1,0h3l0.7-4.8L5,4z"
  })))))), react_1.default.createElement("g", {
    id: "Rectangle_2342"
  }, react_1.default.createElement("rect", {
    x: "1090.6",
    y: "-111.2",
    className: "st3",
    style: {
      fill: '#19232D'
    },
    width: "117",
    height: "230"
  }), react_1.default.createElement("rect", {
    x: "1091.1",
    y: "-110.7",
    className: "st3",
    style: {
      fill: '#19232D'
    },
    width: "116",
    height: "229"
  })));
};

exports.default = Paypal;
Paypal.displayName = 'Paypal';